import { Typography, Button } from '@mui/material';
import noNotifications from '../assets/no-notifications.svg';
import noData from '../assets/no-data.svg';
import noAccess from '../assets/no-access.svg';
import error from '../assets/error.svg';
import noCustomers from '../assets/no-customers.svg';
import noResults from '../assets/no-results.svg';
import ReplayIcon from '@mui/icons-material/Replay';

// Illustrations are from https://undraw.co

const config = {
  notification: {
    image: noNotifications,
    title: "You're all caught up!",
    subtitle: "We'll notify you when something arrives.",
    showBack: false,
  },
  table: {
    image: noData,
    title: 'No requests yet ...',
    subtitle: 'Requests will appear here once they are created.',
    showBack: false,
  },
  noaccess: {
    image: noAccess,
    title: 'Access Denied',
    subtitle:
      'You do not have permission to view this page.\nPlease contact your administrator to request access.',
    showBack: true,
  },
  error: {
    image: error,
    title: 'Oops! Something has gone wrong!',
    subtitle: "Don't worry, we've been notified and our team is already looking into a fix.",
    showBack: true,
  },
  nocustomers: {
    image: noCustomers,
    title: 'No customer assignments yet',
    subtitle:
      'You haven’t been assigned to any customers just yet. \nTo start using the portal, please contact your administrator.',
    showBack: false,
  },
  noresults: {
    image: noResults,
    title: 'No results found',
    subtitle: "We couldn't find what you were looking for.",
  },
  noevents: {
    image: noData,
    title: 'No upcoming events!',
    subtitle: "Event's scheduled to occur soon are shown here.",
  },
};

// Main fallback component, used for failed/empty states
const FallbackPage = ({ type }) => {
  return (
    <div
      className="col align-center justify-center gap"
      style={{ margin: 'auto', height: '100%', minHeight: '480px' }}
    >
      <img src={config[type].image} style={{ maxHeight: '120px', marginBottom: '24px' }} />
      <Typography variant="h6">{config[type].title}</Typography>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
        {config[type].subtitle}
      </Typography>
      {config[type].showBack && (
        <Button
          onClick={() => (window.location.href = '/')}
          sx={{ marginTop: 2 }}
          disableElevation
          variant="contained"
          color="error"
          // startIcon={<ArrowBackRoundedIcon />}
          endIcon={<ReplayIcon />}
        >
          Reload App
        </Button>
      )}
    </div>
  );
};

export default FallbackPage;
